// extracted by mini-css-extract-plugin
export default {"filters":"styles_filters__SCP1O","filters__typeWrapper":"styles_filters__typeWrapper__nBlu5"};